import React from 'react';
import styled from 'styled-components';
import IntlObject from '../Common/IntlObject';

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const AuthBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
    color: #fff;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.4);
  }

  svg {
    flex-shrink: 0;
  }
`;

const UserIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const LogoutIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16,17 21,12 16,7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

function AuthButton({ isLoggedIn }) {
  if (isLoggedIn) {
    return (
      <ButtonGroup>
        <AuthBtn data-bs-toggle="modal" data-bs-target="#logoutModal">
          <LogoutIcon />
          <IntlObject keycode="topbar.logout" returnType="span" />
        </AuthBtn>
      </ButtonGroup>
    );
  }

  return (
    <AuthBtn data-bs-toggle="modal" data-bs-target="#loginModal">
      <UserIcon />
      <IntlObject keycode="topbar.login" returnType="span" />
    </AuthBtn>
  );
}

export default AuthButton;
